export enum ValuationSource {
  Manual = 0,
  BlackBook = 1,
  PriceDigest = 2
}

export const ValuationSourceMapping: Record<ValuationSource, string> = {
  [ValuationSource.Manual]: 'Manual',
  [ValuationSource.BlackBook]: 'Black Book',
  [ValuationSource.PriceDigest]: 'Price Digest'
};
